import { IntlLocale } from "../enum/IntlLocale";

export const removeDiacritics = (str: string) => {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
};

export const formatNumber = (number: number, locale: IntlLocale = IntlLocale.SLOVAK) => {
    return new Intl.NumberFormat(locale).format(number);
}

export const formatPercent = (number: number, maximumFractionDigits: number = 2, locale: IntlLocale = IntlLocale.SLOVAK) => {
    return new Intl.NumberFormat(locale, { style: "percent", maximumFractionDigits }).format(number);
}

export const capitalizeSentences = (str: string) => {
    return str.replace(/(^\w{1})|(\.\s+\w{1})/g, (letter) => letter.toUpperCase());
}

// Function takes string and maximum chars but it cut based on words and add ... at the end
export const cutStringByWords = (str: string, maxChars: number) => {
    if (str.length <= maxChars) return str;
    const words = str.split(" ");
    let result = "";
    for (let i = 0; i < words.length; i++) {
        if ((result + words[i]).length > maxChars) {
            return result + "...";
        }
        result += words[i] + " ";
    }
    return result;
}

export const isAbsoluteUrl = (url: string) => /^(https?:\/\/|\/\/)/.test(url);